import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  table: {
    minWidth: 650,
    tableLayout: "fixed",
  },
  link: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.87);",
  },
  tCenter: {
    textAlign: "center",
  },
  tTruncate: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
  },
}));
